module.exports = __webpack_public_path__ + "logo_blue@2x.4c69a222.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/logo_blue@2x.png
// module id = FG4y
// module chunks = 0